export const initialFormState = {
  selectedPlanName: '',
  smartCardNumber: '',
  customerName: '',
  phone: '',
  selectedPlanCode: '',
  amount: '',
  cycles: [],
  cycle: '',
  transaction_pin: '',
};

const BettingPaymentReducer = (formState, { type, payload }) => {
  switch (type) {
    case "UPDATE_FORM_STATE":
      return { ...formState, ...payload };
    default:
      return formState;
  }
};

export default BettingPaymentReducer;
